import {EntitiesProperties} from "./enums"


export class ScrapingUtils {


//--------------------------------------------------------------------------
// 					            	Clean Number From Signs Sync
//					             ==============================
//
// General 		  :  Removes from string all signs except numeric digits.
//
// Parameters 	:
//                 sStringToClean - String, that we want to clean from signs.
//
// Return Value :  Number, the numeric value of the digits that were
//                 contained in the given string.
//
//---------------------------------------------------------------------------
    public static numericStringToNumber(numericString: string): number {
        let cleanString: string[] = [];

        for (let i = 0; i < numericString.length; i++) {
            const char = numericString[i];

            if ('0' <= char && char <= '9') {
                cleanString.push(char);
            }
        }

        return Number(cleanString);
    }


//-----------------------------------------------------------------------------------------------
// 					                        Number To String Sync
//					                      ==========================
//
// General 		  :  Converte numeric value to custom string (with signs like '$',%','.',',').
//
// Parameters 	:
//                 nNumber - Number, the number to covert.
//
//
// Return Value :  String, with numeric signs.
//
//------------------------------------------------------------------------------------------------
    public static stringToNumericString(nValueToConvert: string) {
        let sConverted = nValueToConvert.toString();

        const objRegex = new RegExp("(-?[0-9]+)([0-9]{3})");
        // Check For Criteria....
        while (objRegex.test(sConverted)) {
            // Add Commas After Every Three Digits Of nValueToConvert...
            sConverted = sConverted.replace(objRegex, "$1,$2");
        }
        return sConverted;
    }

//-----------------------------------------------------------------------------------------------
// 					                        String To Number Sync
//					                      ========================
//
// General 		  :  Converte string value (with signs like '$',%','.',',') to pure numeric number.
//
// Parameters 	:
//                 sStringToConvert - Number, the number to covert.
//
//
// Return Value :  String, with numeric signs.
//
//------------------------------------------------------------------------------------------------
    public static stringToNumberSync(sStringToConvert: string) {
        return Number(ScrapingUtils.numericStringToNumber(sStringToConvert));
    }

//-----------------------------------------------------------------------------------------------
// 					                       Add Signs To Totals Value Sync
//					                      =================================
//
// General 		  :  Customize string values with numeric signs like '$',%','.',','.
//
// Parameters 	:
//                 sPropertyName - String, the property name of the nTotalsValue.
//                 nTotalsValue        - Number, the value we want to add signs to him.
//
//
// Return Value :  String, with numeric signs.
//
//------------------------------------------------------------------------------------------------
    public static addSignsToMetricValue(metricName: string, metricValue: number): string {
        if (isNaN(metricValue) || !metricValue) {
            return "--"
        }
        ;

        switch (metricName.trim().toLowerCase()) {
            case EntitiesProperties.NUMERIC.ALL.CPM.toLowerCase():
                return "$" + ScrapingUtils.stringToNumericString(metricValue.toFixed(2));

            case EntitiesProperties.NUMERIC.ALL.REVENUE.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.PROFIT.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.COST.toLowerCase():
                return "$" + ScrapingUtils.stringToNumericString(metricValue.toFixed(2));

            case EntitiesProperties.NUMERIC.ALL.OPPORTUNITIES.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.IMPRESSIONS.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.REQUESTS.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.RATINGS.toLowerCase():
                return ScrapingUtils.stringToNumericString(metricValue.toFixed(0));

            case EntitiesProperties.NUMERIC.ALL.FILL_RATE.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.FILL.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.CTR.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.VCR.toLowerCase():
            case EntitiesProperties.NUMERIC.ALL.PROFIT_PERCENT.toLowerCase():
                return metricValue.toFixed(2) + "%";

            default:
                return ScrapingUtils.stringToNumericString(metricValue.toString());
        }
    }

//-----------------------------------------------------------------------------
//                        Calculate CPM Sync
//                       ====================
//
// General      : Calculates cpm by formula
//                ( revenue / (impressions/ 1000)).
//
// Parameters   :
//          nRevenue     - Number, the revenue value.
//          nImpressions - Number, the number of impressions.
//
//
// Return Value : Number, the calculated value of the cpm formula.
//
//-----------------------------------------------------------------------------
    public static calcCPM(revenue: number, impressions: number) {
        return impressions === 0 ? 0 : revenue / (impressions / 1000);
    }

//-----------------------------------------------------------------------------
//                        Calculate Fill Sync
//                       ----------------------
//
// General      : Calculates fill rate by formula
//                (impressions/ requests * 100 ).
//
// Parameters   :
//          nImpressions - Number, the number of impressions.
//          nRequests    - Number, the number of requests.
//
//
// Return Value : Number, the calculated value of the fill formula.
//
//-----------------------------------------------------------------------------
    public static calcFill(impressions: number, requests: number) {
        return requests === 0 ? 0 : (impressions / requests) * 100;
    }

//-----------------------------------------------------------------------------------
//                         Is Numeric Property Sync
//                        ===========================
//
// General      : Checks if property is numeric.
//
// Parameters   :
//         sPropertyName - String, The property name that we want to check.
//
//
// Return Value : Boolean, true if the property is numeric, else returns false.
//
//------------------------------------------------------------------------------------
    public static isNumericProperty(prop: string): boolean {
        for (const attribute in EntitiesProperties.NUMERIC.ALL) {
            if (prop === (EntitiesProperties.NUMERIC.ALL as { [key: string]: string })[attribute]) return true;
        }

        return false;
    }

//-----------------------------------------------------------------------------------
//                         Is Not Numeric Property Sync
//                        ==============================
//
// General      : Checks if property is not numeric.
//
// Parameters   :
//         sPropertyName - String, The property name that we want to check.
//
//
// Return Value : Boolean, true if the property is in the not-numeric
//                category in the attributes enum, else returns false.
//
//------------------------------------------------------------------------------------
    public static isNotNumericProperty(prop: string) {
        let bIsNotNumeric = false;

        for (const attribute in EntitiesProperties.NOT_NUMERIC) {
            const sEnumValue = (EntitiesProperties.NOT_NUMERIC as { [key: string]: string })[attribute];
            if (prop === sEnumValue) {
                bIsNotNumeric = true;
            }
        }

        return bIsNotNumeric;
    }


    /**
     * @desc Calculates in percent, the change between 2 numbers.
     * e.g from 1000 to 500 = -50%
     *
     * @param oldValue The initial value
     * @param newValue The value that changed.
     */
    public static getPercentChange(oldValue: number, newValue: number) {
        if (oldValue === 0 || newValue === 0) {
            return 0;
        }

        return ((newValue - oldValue) / oldValue) * 100;
    }
}